module.exports = __webpack_public_path__ + "static/media/circle-check.d15da0eb.svg";